import React from 'react';
import "../../components/Skeleton/Skeleton.scss";

const CreationSkeleton = ({ width = "100%", height = "224px", borderRadius = "12px" }) => {
    return (
        <div className='d-flex f-column' style={{width}}>
            <div className='d-flex f-row aic'>
                <div
                    className="skeleton"
                    style={{ width: "32px", height: '32px', borderRadius: '60px' }}
                />
                <div
                    className="skeleton ml-12"
                    style={{ width: "120px", height: '12px', borderRadius: '60px' }}
                />
            </div>
            <div
                className="skeleton mt-12"
                style={{ width, height, borderRadius }}
            />
            <div
                className="skeleton mt-12"
                style={{ width, height:'12px', borderRadius }}
            />
            <div
                className="skeleton mt-12"
                style={{ width:"120px", height:'12px', borderRadius }}
            />
        </div>
    );
}
export default CreationSkeleton;
